// extracted by mini-css-extract-plugin
export default {"Link":"link-cell-module__Link__qc7nHe9"};